import BaseApiClient from '../BaseApiClient';
import { ActivityLogInterface } from '@interfaces/ActivityLog.interface';
import { ListDataParams, ListDataResponse } from '@api-client/types';

export class ApiActivityLog extends BaseApiClient {
  /**
   * Get task logs
   */
  async listTaskLogs(
    taskId: number,
    listData: ListDataParams
  ): Promise<ListDataResponse<ActivityLogInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(`/activity-log/task/${taskId}`, listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
  /**
   * Get company logs
   */
  async listCompanyLogs(
    companyId: number,
    listData: ListDataParams
  ): Promise<ListDataResponse<ActivityLogInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(`/activity-log/company/${companyId}`, listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
  async listIndividualLogs(
    individualId: number,
    listData: ListDataParams
  ): Promise<ListDataResponse<ActivityLogInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(`/activity-log/individual/${individualId}`, listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  async listAkoniIndexUserLogs(
    akoniIndexUserId: number,
    listData: ListDataParams
  ): Promise<ListDataResponse<ActivityLogInterface>> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(`/activity-log/akoni-index-user/${akoniIndexUserId}`, listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
  async listProductLogs(
    productId: string,
    listData: ListDataParams
  ): Promise<ListDataResponse<ActivityLogInterface> | null> {
    return new Promise((resolve, reject) => {
      this.client
        .getList(`/activity-log/product/${productId}`, listData)
        .then((res) => {
          if (res.status !== 200) {
            return resolve(null);
          }
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Get activity log types for filter options
   */
  async getActivityLogTypes(): Promise<Array<{ name: string; value: string }>> {
    return new Promise((resolve, reject) => {
      this.client
        .get('/activity-log-types')
        .then((res) => {
          if (res.data) {
            resolve(res.data.data || []);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { activityLogQueryKeys } from './query-keys';
export {
  useActivityLogAkoniIndexUserLogsQuery,
  useActivityLogCompanyLogsQuery,
  useActivityLogIndividualLogsQuery,
  useActivityLogProductLogsQuery,
  useActivityLogTaskLogsQuery,
  useActivityLogTypesQuery
} from './use-activity-log-queries';

